import { render, staticRenderFns } from "./SectionPager.vue?vue&type=template&id=2ecb5248&"
import script from "./SectionPager.vue?vue&type=script&lang=js&"
export * from "./SectionPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecb5248')) {
      api.createRecord('2ecb5248', component.options)
    } else {
      api.reload('2ecb5248', component.options)
    }
    module.hot.accept("./SectionPager.vue?vue&type=template&id=2ecb5248&", function () {
      api.rerender('2ecb5248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/section-pager/SectionPager.vue"
export default component.exports